import { StatusInService, UpdateAbsent } from "../../../types/common.interface";
import customAxios from "../../customAxios";
import { APPROVE_DRIVER, UPDATE_ABSENT } from "../../routes";

const updateAbsent = async ({
  absentId,
  isChecked,
  statusInService,
  description,
}: UpdateAbsent) => {
  let body: UpdateAbsent = { absentId };

  if (isChecked !== undefined) {
    body = { ...body, isChecked };
  }
  if (statusInService !== undefined) {
    body = { ...body, statusInService };
  }
  if (description !== "") {
    body = { ...body, description };
  }

  try {
    return (await customAxios.put(UPDATE_ABSENT, body)).data;
  } catch (error: unknown) {
    console.error({ APPROVE_DRIVER: error });
    return false;
  }
};

export default updateAbsent;
